import React from "react"

export const Footer = (props) => {
  return (
    <footer
      className="sticky-footer"
      style={{ paddingTop: 150, paddingBottom: 50 }}
    >
      <div className="container my-auto">
        <div className="copyright text-center my-auto">
          <p>Footer</p>
          <br />
        </div>
      </div>
    </footer>
  )
}

export default Footer
